import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfVideo from '@elem/ui/ef-video';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3Plus');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const IS_AU = locale === 'au';
    const imgAllA = {
        JP: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1723608475282/UPS2.jpg',
        },
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724661432405/tt2.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725158112615/eu1.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725163444923/uk1.jpg',
        },
        AU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736844622484/k1.jpg',
        },
    };
    const imgLocaleA: any = {
        jp: imgAllA.JP,
        us: imgAllA.NA,
        ca: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        au: imgAllA.AU,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];

    const imgAllB = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1724661396066/tt1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1724661372692/tt1.jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1725158329637/eu2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1725158329460/eu2.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1725163492040/uk2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1725163444757/uk2.jpg',
        },
        AU: {
            pc: '',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1736844622108/k2.jpg',
        },
    };
    const imgLocaleB: any = {
        jp: imgAllB.NA,
        us: imgAllB.NA,
        ca: imgAllB.NA,
        uk: imgAllB.UK,
        eu: imgAllB.EU,
        de: imgAllB.EU,
        fr: imgAllB.EU,
        it: imgAllB.EU,
        es: imgAllB.EU,
        au: imgAllB.AU,
    };
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const ReplayIcon = function (props: any) {
        return (
            <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
                <rect x="0.0976562" width="32" height="32" rx="16" fill="#424242" />
                <path
                    d="M19.1009 9.44331C18.1885 9.01756 17.1707 8.77979 16.0974 8.77979C12.1701 8.77979 8.98633 11.9635 8.98633 15.8909C8.98633 16.9941 9.23755 18.0387 9.68592 18.9705M12.6694 22.1227C13.686 22.6831 14.8545 23.002 16.0974 23.002C20.0248 23.002 23.2086 19.8183 23.2086 15.8909C23.2086 14.6502 22.8908 13.4837 22.3323 12.4684"
                    stroke="white"
                    strokeWidth="1.33333"
                    strokeLinecap="round"
                />
                <path d="M17.2861 7.46069L19.1001 9.44351" stroke="white" strokeWidth="1.42222" strokeLinecap="round" />
                <path d="M12.6689 22.1228L14.6748 24.3642" stroke="white" strokeWidth="1.42222" strokeLinecap="round" />
            </svg>
        );
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className={IS_NA_SITES ? 'spec-m' : 'spec-x'} />
            <EfSection
                label={t('K_label')}
                title={t.rich('K_title', {
                    sup: (tx: string) => <sup className="sup">{tx}</sup>,
                })}
                theme={IS_NA_SITES || IS_AU ? 'white' : 'black'}
            />
            <div className={`SectionA-list ${IS_NA_SITES || IS_AU ? 'black' : 'white'}`}>
                <div className="SectionA-item">
                    <p className="SectionA-item-msg">
                        {t.rich('K_card1', {
                            sup: (tx: string) => <sup className="sup">{tx}</sup>,
                        })}
                    </p>
                    <div className="SectionA-item-img">
                        <EfImg pc={imgA.pc} />
                    </div>
                </div>
                <div className="SectionA-item">
                    <p className="SectionA-item-msg">
                        {t.rich('K_card2', {
                            sup: (tx: string) => <sup className="sup">{tx}</sup>,
                        })}
                    </p>
                    <div className="SectionA-item-img">
                        {imgB.pc ? <EfVideo poster={imgB.poster} pc={imgB.pc} Icon={ReplayIcon} /> : <EfImg pc={imgB.poster} />}
                    </div>
                </div>
            </div>
        </div>
    );
}
